module.exports = __webpack_public_path__ + "assets/edit.d5b8dc51.svg";